<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      :uploadField="false"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="roles"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.menu_items`]="{ item }">
              {{ item.menu_items.length }} menu item{{
                item.menu_items.length === 1 ? "" : "s"
              }}
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createRole"
        @update="updateRole"
        :role="role"
        :edit="editMode"
        :menuItems="menuItems"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="role"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/roles/form.vue";
import searchBar from "@/components/searchBar.vue";
import { roleHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      role: {},
      currentItem: {},
      showDialog: false,
      roles: [],
      menuItems: [],
      search: "",
      headers: roleHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Roles" }]);
    this.initialise();
    this.getMenuItems();
  },
  methods: {
    initialise() {
      this.getRoles();
    },
    async getRoles() {
      await this.$axios
        .get("roles")
        .then((res) => {
          this.roles = res.data.data.sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getMenuItems() {
      await this.$axios.get("menu_items").then((res) => {
        this.menuItems = res.data.data;
      });
    },
    async createRole(data) {
      await this.$axios
        .post("roles", { role: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Role created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateRole(data) {
      await this.$axios
        .put("roles/" + data.id, { role: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Role updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateRole({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    edit(item) {
      this.role = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.role = {};
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = this.showActiveStatus(item.active);
      return (
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.code.toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
